import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MembershipService } from '@app/services/membership.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { Subscription } from 'rxjs';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-terminatemembershipstorloge',
  templateUrl: './terminatemembershipstorloge.component.html',
  styleUrls: ['./terminatemembershipstorloge.component.css']
})
export class TerminatemembershipstorlogeComponent implements OnChanges, OnDestroy, OnInit {
  @Input() memberid: number;
  @Input() givenname: string;
  @Input() familyname: string;
  @Input() primarylodgeformember: number;
  @Output() closeTerminateStorloge: EventEmitter<any> = new EventEmitter();
  terminatemembershipstorlogeform;
  

  subscriptions: Subscription[] = [];
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private membershipService: MembershipService,
    private snackbarService: SnackbarService,
    private confirmationService: ConfirmationService) { }

    ngOnInit(): void {
      this.terminatemembershipstorlogeform = this.fb.group({
        memberId: ['', ''],
        institutionId: ['', ''],
        fromDate: ['', Validators.required],
        gott: ['', Validators.required],
        action: ['update', '']
      });
    }
    
  ngOnChanges(_: SimpleChanges) {
    if (_ && this.terminatemembershipstorlogeform) {
    this.terminatemembershipstorlogeform.get('memberId').setValue(this.memberid.toString());
    this.terminatemembershipstorlogeform.get('institutionId').setValue(this.primarylodgeformember.toString());
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  close() {
    this.closeTerminateStorloge.emit();
  }

  save() {
    const data = {
      memberId: this.memberid,
      institutionId: this.terminatemembershipstorlogeform.get('institutionId').value,
      causeId: this.terminatemembershipstorlogeform.get('gott').value,
      date: this.terminatemembershipstorlogeform.get('fromDate').value
    };
    this.subscriptions.push(this.membershipService.EndMemberMembershipSL(data).subscribe(response => {
      this.snackbarService.openSnackBar(response, null);
      this.close();
    }));
  }

  confirmDialog(): void {
      this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avsluta medlemskapet?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.save();
      },
      reject: () => {
      }
    });
  }
}
